import { MessageCircle } from "lucide-react";

interface PatientScriptProps {
  script: string;
}

export function PatientScript({ script }: PatientScriptProps) {
  return (
    <div className="rounded-xl border border-clinical-green/30 bg-clinical-green/5 p-4">
      <div className="mb-2 flex items-center gap-2">
        <MessageCircle className="h-4 w-4 text-clinical-green" />
        <h3 className="text-xs font-semibold uppercase tracking-wider text-clinical-green">
          외래 설명용 스크립트
        </h3>
      </div>
      <blockquote className="border-l-2 border-clinical-green/40 pl-3 text-sm italic leading-relaxed text-foreground/80">
        &ldquo;{script}&rdquo;
      </blockquote>
    </div>
  );
}
